export class WeightClassGroupWeight {
    public id: string = null;
    public name: string = null;
    public minWeight: number = null;
    public maxWeight: number = null;
    public sequence: number = 0;

    public clone(): WeightClassGroupWeight {
        const clone: WeightClassGroupWeight = new WeightClassGroupWeight();
        clone.id = this.id;
        clone.name = this.name;
        clone.minWeight = this.minWeight;
        clone.maxWeight = this.maxWeight;
        clone.sequence = this.sequence;
        return clone;
    }

    /**
     * Deserialize from a json api format
     */
    public deserialize(json: Object): WeightClassGroupWeight {
        const data: Object = json['data'] || json;
        const attrs: Object = data['attributes'] || [];

        this.id = data['id'];
        this.name = attrs['name'];
        this.minWeight = attrs['minWeight'] && parseFloat(attrs['minWeight']);
        this.maxWeight = attrs['maxWeight'] && parseFloat(attrs['maxWeight']);
        this.sequence = attrs['sequence'];

        return this;
    }
}
